import { render, staticRenderFns } from "./IncludeMenu.vue?vue&type=template&id=245645e8&scoped=true"
import script from "./IncludeMenu.vue?vue&type=script&lang=js"
export * from "./IncludeMenu.vue?vue&type=script&lang=js"
import style0 from "./IncludeMenu.vue?vue&type=style&index=0&id=245645e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245645e8",
  null
  
)

export default component.exports